import { JsonLogicOperator } from '@jira/polaris__domain-field/src/jsonLogicOperator.constants.tsx';
import type { RulesLogic } from '@jira/polaris__domain-field/src/ValueDecoration.types.tsx';
import jsonLogic from '@jira/polaris__lib-json-logic/src/index.tsx';
import type { RangeType } from './RangeType.types.tsx';

export const createBetweenLogic = (gte = 0, lte = 0): RulesLogic => {
	return { [JsonLogicOperator.LTE]: [gte, { var: 'value' }, lte] };
};

export const createLessThanLogic = (lte = 0): RulesLogic => {
	return { [JsonLogicOperator.LT]: [{ var: 'value' }, lte] };
};

export const createGreaterThanLogic = (gte = 0): RulesLogic => {
	return { [JsonLogicOperator.GT]: [{ var: 'value' }, gte] };
};

export const createDefaultLogic = (type: RangeType): RulesLogic => {
	switch (type) {
		case 'GT':
			return createGreaterThanLogic();
		case 'LT':
			return createLessThanLogic();
		case 'BT':
			return createBetweenLogic();
		default:
			throw new Error('Invalid range type');
	}
};

export const applyNumberLogic = (logic: RulesLogic, value: number): boolean => {
	return jsonLogic.apply(logic, { value });
};
